import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';

/**
 * Validator custom: Vérifie qu'une date est après une autre
 * 
 * @example
 * class CreateAssignmentDto {
 *   availableFrom: Date;
 *   
 *   @IsAfter('availableFrom')
 *   dueAt: Date;
 * }
 */
@ValidatorConstraint({ name: 'isAfter', async: false })
export class IsAfterConstraint implements ValidatorConstraintInterface {
  validate(value: any, args: ValidationArguments): boolean {
    const [relatedPropertyName] = args.constraints;
    const relatedValue = (args.object as any)[relatedPropertyName];
    
    if (!value || !relatedValue) {
      return true; // Skip validation if either value is missing
    }

    const date1 = new Date(relatedValue);
    const date2 = new Date(value);

    return date2 > date1;
  }

  defaultMessage(args: ValidationArguments): string {
    const [relatedPropertyName] = args.constraints;
    return `${args.property} doit être après ${relatedPropertyName}`;
  }
}

export function IsAfter(property: string, validationOptions?: ValidationOptions) {
  return function (object: any, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [property],
      validator: IsAfterConstraint,
    });
  };
}

/**
 * Validator custom: Vérifie qu'une date n'est pas dans le passé
 */
@ValidatorConstraint({ name: 'isNotPast', async: false })
export class IsNotPastConstraint implements ValidatorConstraintInterface {
  validate(value: any): boolean {
    if (!value) {
      return true; // Skip if optional
    }

    const date = new Date(value);
    const now = new Date();

    return date >= now;
  }

  defaultMessage(): string {
    return 'La date ne peut pas être dans le passé';
  }
}

export function IsNotPast(validationOptions?: ValidationOptions) {
  return function (object: any, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: IsNotPastConstraint,
    });
  };
}
